<script setup>
import { nextTick, onMounted, onUnmounted } from "vue";
import { bus, RUN_GUIDE, GUIDE_REGISTER, GUIDE_UNREGISTER } from "@/bus/bus";
import { getDriver } from "@/tours/driverInstance";
import { buildDashboardSteps } from "@/tours/dashboardTour";

const drv = getDriver();

function focusIntoView(sel) {
  const el = document.querySelector(sel);
  if (!el) return;
  el.scrollIntoView({ behavior: "instant", block: "center" });
  requestAnimationFrame(() => drv.refresh());
}

async function run() {
  drv.setSteps(buildDashboardSteps(focusIntoView));
  await nextTick();
  requestAnimationFrame(() => {
    drv.drive();
    requestAnimationFrame(() => drv.refresh());
  });
}

// ✅ mitt 이벤트 받아서 run 실행
const handler = () => run();

onMounted(() => {
  const handler = () => run();                 // 이미 있는 run() 호출
  bus.emit(GUIDE_REGISTER);                    // ✅ 등록
  bus.on(RUN_GUIDE, handler);
  // 언마운트 클린업
  onUnmounted(() => {
    bus.off(RUN_GUIDE, handler);
    bus.emit(GUIDE_UNREGISTER);                // ✅ 해제
  });
});

// 필요하면 외부 직접 호출도 가능하게 유지
defineExpose({ run });
</script>

<template></template>
